module.exports = __webpack_public_path__ + "static/media/Layout4.aa2001ad.png";